// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navigation_nav__PUbfU","sub":"Navigation_sub__1UckH","logo":"Navigation_logo__393xY","btn":"Navigation_btn__2idBg","subnav":"Navigation_subnav__3d070"};